import ReactEDSWrapper from '../../../utils/react-eds-wrapper';
import { Button, Dialog } from '@dsi/react-eds';
import styles from './TestCollectionList.module.css';
import { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useLoader } from '../../../hooks/useLoader';
import api from '../../../api/axiosInstance';
import { useSwobNotifications } from '../../../hooks/NotificationsProvider';
import { AxiosError } from 'axios';
import { TestCollection } from './TestCollectionInterfaces';

export interface DeleteTestCollectionDialogProps {
  open: boolean;
  testCollection: TestCollection | undefined;
  onDelete: () => void;
  onCancel: () => void;
}

const DeleteTestCollectionDialog: React.FC<DeleteTestCollectionDialogProps> = ({ open, testCollection, onDelete, onCancel }) => {
  useEffect(() => {
      if (open) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
      return () => {
        document.body.style.overflow = '';
      };
    }, [open]);

  const { addNotifications } = useSwobNotifications();
  const { showLoader, hideLoader } = useLoader();

  const deleteTestCollection = async () => {
    showLoader();
    try {
        await api.delete(`/api/test-collections/${testCollection?.id}`);
        onDelete();
        addNotifications([
            {
            title: 'Success',
            icon: 'icon-success',
            description: `Test Collection: ${testCollection?.testCollectionName}, deleted successfully`,
            timestamp: new Date(),
            color: 'green'
            }
        ]);
    } catch (error: unknown) {
        console.error(error);
        addNotifications([
            {
            title: 'Error',
            icon: 'icon-triangle-warning',
            description:
                error && error instanceof AxiosError
                ? error.response?.data?.message || error.message
                : 'An error occurred deleting Test Collection',
            timestamp: new Date(),
            color: 'red'
            }
        ]);
        onCancel();
    } finally {
        setTimeout(() => {
            hideLoader();
        }, 500);
    }
  };

  return ReactDOM.createPortal(
    <ReactEDSWrapper
      component={Dialog}
      show={open}
      onClose={onCancel}
      title="Delete Test Collection"
      subtitle="Test Automation"
      bottom={
        <ReactEDSWrapper
          component={Button}
          variant="primary"
          className="btn primary"
          type="button"
          onClick={deleteTestCollection}
        >
          Delete Test Collection
        </ReactEDSWrapper>
      }
    >
      <div className={styles.whiteText}>
        You're about to remove this test collection [<strong>{testCollection?.testCollectionName}</strong>] from the list.<br />
        This action is permanent and cannot be undone.<br /><br />
        Are you sure you want to continue?
      </div>
    </ReactEDSWrapper>, document.body
  );
};

export default DeleteTestCollectionDialog;
